var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 43,
    viewBox: "0 0 438 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 250,
    r: 100,
    fill: "#e24c4b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerInactive);
export default __webpack_public_path__ + "static/media/customer_inactive.46ec213180940c115bcc6838e40015d8.svg";
export { ForwardRef as ReactComponent };